import React, { useMemo } from 'react';
import { useLang } from '../../../../util/lang';
import { getWebAbsPath } from '../../../../util/path';
import { renderToothMarkers } from '../../NewPatientUtill';
import useDisplayRestorativeOptionValue from '../../../../hooks/useDisplayRestorativeOptionValue';

const SubQuestionTitle = ({ children }) => {
    if (!children) return null;
    return <strong style={{ color: 'rgba(0,0,0,0.87)' }}>{children}</strong>;
};

const ViewRestorativeOptions = ({
    restorative_options = '',
    vertical_dimension_upper_posterior = '',
    vertical_dimension_lower_posterior = '',
    onlay_position = [],
    teeth,
}) => {
    const getLang = useLang();
    const { getValueDisplay } = useDisplayRestorativeOptionValue();

    const isRenderValue = useMemo(() => {
        const isPosteriorValid =
            vertical_dimension_upper_posterior?.length > 0 || vertical_dimension_lower_posterior?.length > 0;

        return restorative_options && isPosteriorValid && onlay_position.length > 0;
    }, [restorative_options, vertical_dimension_upper_posterior, vertical_dimension_lower_posterior, onlay_position]);

    if (!isRenderValue) {
        return <li>{getLang('@global.const.no')}</li>;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, color: 'red' }}>
            <li>
                {restorative_options.length > 0
                    ? getLang(`@NewPatient.prescriptionNotes.${restorative_options}`)
                    : getLang('@global.const.no')}
            </li>
            <SubQuestionTitle>{getLang('@NewPatient.prescriptionNotes.verticalDimensionQuestion')}</SubQuestionTitle>
            <li>
                {getLang('@NewPatient.prescriptionNotes.upperPosterior')}:
                {getValueDisplay(vertical_dimension_upper_posterior)}
            </li>
            <li>
                {getLang('@NewPatient.prescriptionNotes.lowerPosterior')}:
                {getValueDisplay(vertical_dimension_lower_posterior)}
            </li>
            <SubQuestionTitle>{getLang('@NewPatient.prescriptionNotes.onlayQuestion')}</SubQuestionTitle>
            <div
                style={{
                    width: 800,
                    height: 200,
                    position: 'relative',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                }}
            >
                {renderToothMarkers(onlay_position, teeth)}
            </div>
        </div>
    );
};

export default ViewRestorativeOptions;
